//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.LexicalItemsFromLLMQuery
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonWriter
import kotlin.Boolean
import kotlin.Suppress

public object LexicalItemsFromLLMQuery_VariablesAdapter {
  @Suppress(
    "UNUSED_PARAMETER",
    "UNUSED_VARIABLE",
  )
  public fun serializeVariables(
    writer: JsonWriter,
    `value`: LexicalItemsFromLLMQuery,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    writer.name("query")
    StringAdapter.toJson(writer, customScalarAdapters, value.query)
    writer.name("langFromIso3")
    StringAdapter.toJson(writer, customScalarAdapters, value.langFromIso3)
    writer.name("langToIso3")
    StringAdapter.toJson(writer, customScalarAdapters, value.langToIso3)
  }
}
